exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".drug2[data-v-90c15db2]{background:#fff;border-radius:2px;padding:15px 10px}.drug2 h3[data-v-90c15db2]:after{content:\" \";width:14px;height:6px;background-color:#f56c6c;display:block;margin:12px 0 20px}.drug2 h4[data-v-90c15db2]{font-size:15px;color:#123;font-weight:600;margin-top:20px;margin-bottom:1px}.drug2 p[data-v-90c15db2]{font-size:15px;font-weight:300;color:#231f20;padding:5px 0;margin:7px 0 0}.drug2 .c-t[data-v-90c15db2]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;margin-top:50px}@media screen and (min-width:900px){.drug2[data-v-90c15db2]{background:#fff;border-radius:2px;padding:15px 15px 50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-90c15db2","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/drug2.vue
// module id = 177
// module chunks = 1